module.exports = __webpack_public_path__ + "static/media/notsuported.395eb69a.jpg";